export default "__VITE_ASSET__CFgZulnK__"